import Api from '@/services/Index';
import qs from "qs";

const getAll = async (config) => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT;
    return Api.get('/calculator-fees',config);
}

const getCalculatorInformation = async () => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT;
    const config={
            params: {
               limit:-1
            },
            paramsSerializer: (params) => qs.stringify(params, {encode: false})
    }
    return Api.get('/calculator-fees/public',config);
}
const store = async (formData) => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT;
    return Api.post('/calculator-fees',formData);
}
const show = async (id) => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT;
    return Api.get('/calculator-fees/'+id);
}
const update = async (id,formData) => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT;
    return Api.put('/calculator-fees/'+id,formData);
}
const del = async (id) => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT;
    return Api.delete('/calculator-fees/'+id);
}

const modalFormSave = async (data) => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT;

    return Api.post('/calculator-fees/pardot-form-handler',data);
}


export default {
    getCalculatorInformation,
    getAll,
    store,
    show,
    update,
    del,
    modalFormSave

}
